import BreadCrumb from "@/src/components/Shared/BreadCrumbs";

import server from "../../src/api/server";
import { useIntl } from "react-intl";
import styles from "@/styles/projects.module.scss";
import SingleBlog from "@/src/components/Home/Blogs/SingleBlog";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { checkRedirect } from "@/src/components/helpers/functions";
import { buildSeoAlternates } from "@/src/components/helpers/seo";

const SingleBlogPage = ({ singleBlog, siteInfo }) => {
  const { locale, formatMessage } = useIntl();
  const seo = singleBlog?.data?.blogObj?.seo;
  const { asPath } = useRouter();
  const { canonical, languageAlternates } = buildSeoAlternates(asPath, locale);

  return (
    <>
      <NextSeo
        title={singleBlog?.title?.[locale] || seo?.title?.[locale]}
        description={
          singleBlog?.description?.[locale] || seo?.description?.[locale]
        }
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <div className={styles.projectsPage}>
        <BreadCrumb
          heading={singleBlog?.data?.blogObj?.title?.[locale]}
          description={`${formatMessage({
            id: "main",
          })} / ${formatMessage({
            id: "blogs",
          })} / ${singleBlog?.data?.blogObj?.title?.[locale]?.slice(0, 50)}${
            singleBlog?.data?.blogObj?.title?.[locale]?.length > 50 && "..."
          }`}
          background={singleBlog?.breadCrumbImage}
        />
        <div className="wrapper">
          <div className="projects-body category-id">
            <SingleBlog
              blogCategory={singleBlog?.blogCategory}
              singleBlog={singleBlog?.data?.blogObj}
              siteInfo={siteInfo}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { id } = ctx.params;
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  try {
    const blogsResponse = await server.get(`/blogs/${id}`);

    if (!blogsResponse?.data?.data?.blogObj) {
      return { notFound: true };
    }

    const blogCategoryId = blogsResponse.data.data.blogObj.category;

    let blogCategory = null;
    if (blogCategoryId) {
      try {
        const categoryResponse = await server.get(
          `/categories/${blogCategoryId}`
        );
        blogCategory = categoryResponse?.data?.data?.category || null;
      } catch (error) {
        console.error(
          "Failed to fetch blog category:",
          error?.response?.status || error.message
        );
      }
    }

    const homeResponse = await server.get("/pages/home");

    const sectionData = (r) => r?.data?.data?.page?.sections || [];
    const homeData = (section) =>
      sectionData(homeResponse)?.find((e) => e?.slug === section) || {};

    return {
      props: {
        singleBlog: {
          ...blogsResponse.data,
          blogCategory: blogCategory,
          breadCurmbImage:
            homeData("intro")?.items?.[0]?.backgroundImage || null,
        },
      },
    };
  } catch (error) {
    console.error(
      "Failed to fetch blog:",
      error?.response?.status || error.message
    );

    return {
      notFound: true,
    };
  }
}

export default SingleBlogPage;
